<template>
  <v-container fluid class="pa-2">

    <div class="traka">
      <h2 class="naslov">Logo i memorandum</h2>
      <div class="podatak">{{ company.CompanyName }}</div>
      <div class="radnje">
        <v-btn small color="white" class="plavi-tekst" :loading="sprema"
          @click="update">Spremi</v-btn>
        <v-btn small text dark @click="natrag">Natrag</v-btn>
      </div>
    </div>

    <v-card tile>
      <div class="naslov-kartice">Slika na ispisu</div>
      <div class="tijelo">
        <div class="uputa">
          Odaberi sliku s računala — pretvorba u zapis koji ispis traži radi se ovdje.
          Dopušteni su <b>PNG</b> i <b>JPG</b>; ispis druge vrste slike ne zna nacrtati.
          Ako je postavljen <b>memorandum</b>, on ima prednost pred logom gore desno,
          a taj pred logom gore lijevo.
        </div>

        <div v-for="p in polja" :key="p.polje" class="slika">
          <div class="pregled">
            <img v-if="company[p.polje]" :src="company[p.polje]" :alt="p.naziv" />
            <div v-else class="nema">nema slike</div>
          </div>

          <div class="opis">
            <div class="ime">
              {{ p.naziv }}
              <span class="oznaka">{{ p.koristi }}</span>
            </div>
            <div class="gdje">{{ p.gdje }}</div>
            <div class="velicina" v-if="company[p.polje]">
              {{ velicina(company[p.polje]) }}
              <span v-if="prevelika(company[p.polje])" class="prevelika">
                &middot; velika slika usporava ispis, preporuka do 200 kB
              </span>
            </div>

            <div class="gumbi">
              <v-btn x-small color="primary" @click="odaberi(p.polje)">
                {{ company[p.polje] ? 'Zamijeni sliku' : 'Odaberi sliku' }}
              </v-btn>
              <v-btn x-small text color="red darken-2" v-if="company[p.polje]"
                @click="ocisti(p.polje)">Obriši</v-btn>
            </div>
          </div>
        </div>

        <!-- Skriveni odabir datoteke; sliku citamo u pregledniku, bez servera
             i bez vanjske stranice za pretvorbu. -->
        <input ref="datoteka" type="file" accept="image/png,image/jpeg"
          style="display:none" @change="ucitaj" />
      </div>

      <!-- Rijetko: rucni upis zapisa slike, za slucaj da sliku dobiju gotovu. -->
      <v-expansion-panels accordion flat class="sklopivo">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Ručni upis zapisa slike (BASE64)
            <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="uputa mb-2">
              Potrebno samo ako sliku dobiješ već pretvorenu. Zapis mora počinjati s
              <code>data:image/png;base64,</code> ili <code>data:image/jpeg;base64,</code>.
              <v-btn x-small text color="primary" @click="base64">vanjska pretvorba</v-btn>
            </div>
            <v-textarea v-for="p in polja" :key="p.polje" outlined dense rows="2"
              class="mb-2" :label="p.naziv" v-model="company[p.polje]"></v-textarea>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider></v-divider>
      <v-card-actions>
        <span class="napomena">
          Nakon spremanja odjavi se i ponovno prijavi — ispis čita logo iz podataka
          prijave.
        </span>
        <v-spacer></v-spacer>
        <v-btn small text @click="natrag">Natrag</v-btn>
        <v-btn small color="primary" :loading="sprema" @click="update">Spremi</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="4000" :color="boja" bottom>
      {{ poruka }}
    </v-snackbar>
  </v-container>
</template>

<script>
import CompService from '@/services/CompService'

// Koliko firmi polje uopce koristi - mjereno na svih 98 tvrtki 15.10.2026.
// Logo2 i Logo3 ne koristi nijedna, pa stoje nize i oznaceni su.
const POLJA = [
  {polje: 'CompanyLogo1', naziv: 'Logo gore lijevo', koristi: '6 firmi',
    gdje: 'Mali logo uz podatke tvrtke na računu i ostalim ispisima.'},
  {polje: 'CompanyLogo2', naziv: 'Logo gore desno', koristi: 'nijedna firma',
    gdje: 'Zamjenjuje mali logo i crta se u gornjem desnom kutu.'},
  {polje: 'CompanyLogo3', naziv: 'Memorandum (puna širina A4)', koristi: 'nijedna firma',
    gdje: 'Zaglavlje preko cijele širine; ima prednost pred oba loga.'}
]

const NAJVECA = 200 * 1024

export default {
  name: 'companyedit',
  data () {
    return {
      company: {},
      polja: POLJA,
      zaPolje: null,
      sprema: false,
      snackbar: false,
      poruka: '',
      boja: 'red'
    }
  },
  async mounted () {
    try {
      const locComp = await CompService.show(this.$store.state.companyid)
      this.company = locComp.data.company || {}
    } catch (error) {
      this.javi('Greška pri dohvatu tvrtke.')
      // eslint-disable-next-line
      console.log('logo tvrtke', error)
    }
  },
  methods: {
    javi (tekst, boja) {
      this.poruka = tekst
      this.boja = boja || 'red'
      this.snackbar = true
    },

    // Prikaz velicine zapisa. BASE64 je oko trecinu veci od same datoteke.
    bajtovi (zapis) {
      const s = String(zapis || '')
      const i = s.indexOf(',')
      return Math.round((i === -1 ? s.length : s.length - i - 1) * 3 / 4)
    },
    velicina (zapis) {
      const b = this.bajtovi(zapis)
      return b > 1024 ? Math.round(b / 1024) + ' kB' : b + ' B'
    },
    prevelika (zapis) {
      return this.bajtovi(zapis) > NAJVECA
    },

    odaberi (polje) {
      this.zaPolje = polje
      // vrijednost se brise da se ista datoteka moze odabrati dvaput zaredom
      this.$refs.datoteka.value = ''
      this.$refs.datoteka.click()
    },

    ucitaj (dogadaj) {
      const datoteka = dogadaj.target.files && dogadaj.target.files[0]
      if (!datoteka || !this.zaPolje) { return }
      if (['image/png', 'image/jpeg'].indexOf(datoteka.type) === -1) {
        this.javi('Dopušteni su samo PNG i JPG.')
        return
      }
      const citac = new FileReader()
      citac.onload = () => {
        this.$set(this.company, this.zaPolje, citac.result)
        if (this.prevelika(citac.result)) {
          this.javi('Slika je ' + this.velicina(citac.result) +
            ' — radit će, ali usporava ispis.', 'orange darken-2')
        } else {
          this.javi('Slika je učitana, još je treba spremiti.', 'green darken-2')
        }
      }
      citac.onerror = () => this.javi('Sliku nije moguće pročitati.')
      citac.readAsDataURL(datoteka)
    },

    ocisti (polje) {
      this.$set(this.company, polje, '')
    },

    async update () {
      this.sprema = true
      try {
        await CompService.put(this.company)
        this.javi('Spremljeno. Odjavi se i prijavi da ispis preuzme novi logo.',
          'green darken-2')
      } catch (error) {
        const o = error && error.response && error.response.data
        this.javi('Greška pri spremanju' + (o && o.error ? ': ' + o.error : '.'))
      }
      this.sprema = false
    },

    async natrag () {
      try {
        await this.$router.push({name: 'companyview'})
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },

    base64 () {
      window.open('https://www.base64-image.de/', '_blank')
    }
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { font-size: 12px; opacity: .9; }
.radnje { margin-left: auto; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.plavi-tekst { color: #0d47a1 !important; }

.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1565c0;
  padding: 7px 12px;
}
.tijelo { padding: 12px; }

.uputa { font-size: 12px; color: #5f6b7a; margin-bottom: 12px; }

.slika {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 10px 0;
  border-top: 1px solid #f0f3f6;
}
.slika:first-of-type { border-top: none; }

.pregled {
  flex: 0 0 160px;
  height: 90px;
  border: 1px solid #e3e8ee;
  border-radius: 3px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.pregled img { max-width: 100%; max-height: 100%; object-fit: contain; }
.pregled .nema { font-size: 12px; color: #bdbdbd; }

.opis { flex: 1 1 auto; min-width: 0; }
.ime { font-weight: 500; }
.gdje { font-size: 12px; color: #5f6b7a; margin-top: 2px; }
.velicina { font-size: 12px; color: #5f6b7a; margin-top: 4px; }
.prevelika { color: #ef6c00; }
.gumbi { margin-top: 8px; display: flex; gap: 8px; }

.oznaka {
  font-size: 11px;
  font-weight: 400;
  color: #5f6b7a;
  background: #eceff1;
  padding: 1px 7px;
  border-radius: 9px;
  margin-left: 8px;
}

.sklopivo >>> .v-expansion-panel-header {
  min-height: 42px;
  padding: 8px 12px;
  font-weight: 500;
  color: #1565c0;
}
.sklopivo >>> .v-expansion-panel { border-top: 1px solid #e3e8ee; }
.sklopivo >>> .v-expansion-panel-content__wrap { padding: 0 12px 12px; }

.napomena { font-size: 12px; color: #5f6b7a; }

@media (max-width: 600px) {
  .slika { flex-wrap: wrap; }
  .pregled { flex: 0 0 100%; }
  .radnje { width: 100%; margin-left: 0; }
}
</style>
